import React, { FC } from 'react';

import { OptionType } from '@evinced-private/ui-common';

import { IScopeRuleUIFormat } from '../../../../interfaces/ScopeRuleUIFormat';
import { SCOPE_TYPES } from '../../../../types/scope/ScopeTypes';
import { IssueSeveritiesRuleRow } from '../scope-rule-row/IssueSeveritiesRuleRow';
import { IssueTypesRuleRow } from '../scope-rule-row/IssueTypesRuleRow';
import { UrlRuleRow } from '../scope-rule-row/UrlRuleRow';

interface IScopeRulesListProps {
	rulesList: IScopeRuleUIFormat[];
	issueTypesList: OptionType[];
	issueSeveritiesList: OptionType[];
	onRemove: (id: string) => void;
	onRuleChange: (rule: IScopeRuleUIFormat) => void;
}

export const ScopeRulesList: FC<IScopeRulesListProps> = ({
	rulesList,
	issueTypesList,
	issueSeveritiesList,
	onRemove,
	onRuleChange
}) => {
	return (
		// eslint-disable-next-line react/jsx-no-useless-fragment
		<>
			{rulesList?.map((rule: IScopeRuleUIFormat) => {
				switch (rule.scopeType) {
					case SCOPE_TYPES.URL:
						return (
							<UrlRuleRow
								key={rule.id}
								rule={rule}
								onRuleChange={onRuleChange}
								onRemove={() => onRemove(rule.id)}
							/>
						);
					case SCOPE_TYPES.ISSUE_TYPES:
						return (
							<IssueTypesRuleRow
								key={rule.id}
								rule={rule}
								issueTypesList={issueTypesList}
								onRuleChange={onRuleChange}
								onRemove={() => onRemove(rule.id)}
							/>
						);
					case SCOPE_TYPES.ISSUE_SEVERITIES:
						return (
							<IssueSeveritiesRuleRow
								key={rule.id}
								rule={rule}
								issueSeveritiesList={issueSeveritiesList}
								onRuleChange={onRuleChange}
								onRemove={() => onRemove(rule.id)}
							/>
						);
					default:
						return null;
				}
			})}
		</>
	);
};
